var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8305 12.0124C19.285 12.3174 18.8994 12.836 18.6795 13.4211C17.237 17.2591 13.4365 19.9999 8.97519 19.9999C5.51968 19.9999 2.46067 18.3557 0.586658 15.8309C0.388666 15.5641 0.587255 15.2 0.919454 15.2C1.05634 15.2 1.18421 15.2668 1.26597 15.3766C2.99085 17.6925 5.80089 19.2 8.97444 19.2C13.1907 19.2 16.7654 16.5392 18.0061 12.8565C18.2339 12.1805 19.0303 11.7669 19.653 11.4187C20.7624 10.7982 20.7624 9.20173 19.653 8.58131C19.0303 8.2331 18.2338 7.81949 18.006 7.14341C16.7653 3.46089 13.1907 0.800086 8.97444 0.800086C5.80094 0.800086 2.99094 2.30752 1.26606 4.62345C1.18428 4.73324 1.0564 4.80002 0.9195 4.80002C0.587258 4.80002 0.388643 4.43587 0.586661 4.16908C2.46068 1.64427 5.51969 0 8.97519 0C13.4365 0 17.237 2.74084 18.6796 6.57889C18.8995 7.16393 19.285 7.68254 19.8305 7.98759C21.4043 8.86766 21.4043 11.1323 19.8305 12.0124Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevels);
export default __webpack_public_path__ + "static/media/levels.36e09d5fac137ab40e53b4a508a9e6cd.svg";
export { ForwardRef as ReactComponent };